export default __webpack_public_path__ + "static/media/J270MANB3.041d8d74.pdf";